import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { onlyContent } = {}) => ({
  layout: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      paddingBottom: onlyContent ? theme.spacing(7) : 'initial',
    },
  },
  emptyMaterials: {
    marginTop: '20vh',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    width: 540,
    [theme.breakpoints.down('md')]: {
      width: 290,
    },
  },
  modalContainer: {
    paddingInline: '116px',
    paddingTop: '10px',
    [theme.breakpoints.down('lg')]: {
      paddingInline: 0,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: '12px',
    },
  },
  productsQtyLabel: {
    marginBottom: theme.spacing(2),
  },
}));
